import { ChangeDetectorRef, Component, ElementRef, Inject, Optional, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { AppService } from 'src/app/services/app/app.service';
import { CourseService } from 'src/app/services/course/course.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { AlertComponent } from '../../alert/alert.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { E } from '@angular/cdk/keycodes';
interface TransformedObject {
  id: number;
  arr: number[];
}

@Component({
  selector: 'app-view-course-preview',
  templateUrl: './view-course-preview.component.html',
  styleUrls: ['./view-course-preview.component.scss']
})
export class ViewCoursePreviewComponent {
  public imageURL: string = GlobalService.imageURL;
  public subSectionData
  public courseData
  public isSpinnerLoading: boolean = false
  public panelOpenState: boolean = false
  public isPlayButton: boolean = true
  coursePreviewType: string = 'desktop'
  public sectionDataArr: any[] = []
  public themeArr: any[] = [
    {
      id: "1",
      img: "assets/images/course-theme/theme1.png"
    },
    {
      id: "2",
      img: "assets/images/course-theme/theme2.png"
    },
  ]
  public selectedTheme: any = {
    id: "",
    img: ""
  };
  @ViewChild('video') video!: ElementRef;
  @ViewChild('audio') audio!: ElementRef;
  public sectionId!: number;
  public subSectionId!: number;
  public courseId!: string;
  public courseType!: string;
  public examData: any = {
    type: 'view_exam'
  }
  public sectionArr: any[] = [];
  // public isCourseOverview: boolean = false;
  public sectionIndex!: number;
  public subSectionIndex!: number;
  // public isAdminPreview: boolean = false;
  // public parentMenu!: string;
  // public isThemeChangeApplicable: boolean = false;
  public isBackAvailable: boolean = false;
  // public themeUrl!: string;
  public isCourseCompleted: boolean = false;
  public previewType = {
    themePreview: false, //selected theme change option if not theme preview it will be course preview
    adminPreview: false,     //opening this view from admin (preview course option on landing page and all)
    // coursePreview:true   ,//viewing the course from portal
    dataFromAPI: true,  //user viewuing it from preview option then data will be from API 
    // when data from API is false it means user has selected course overview option
    // dataFromLocal:false,  // USER selected course overview then data will be from local i.e will be passed throught modal
    parentMenu: ""
  }
  public freePreviewTimOut:any;
  constructor(public sanitizer: DomSanitizer, private courseService: CourseService, @Optional() public dialogRef: MatDialogRef<ViewCoursePreviewComponent>,
    private cookieService: CookieService, @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any, private appService: AppService,
    private dialog: MatDialog, private spinner: NgxSpinnerService,private cd:ChangeDetectorRef
  ) { }
  onResize(event: Event) {
    // this.checkScreenWidth();
  }
  ngOnInit(): void {
    if (window.location.href.includes('admin-course-preview')) {
      this.previewType.adminPreview = true;
    }
    else {
      if (this.dialogData.parentMenu == "preview_course") {
        this.previewType.dataFromAPI = true
      }
      else {
        this.previewType.dataFromAPI = false
        if (this.dialogData.isThemePreview) {
          this.previewType.themePreview = true;
        }
      }
    }
    this.getPageDetail()
  
  }
  getPageDetail() {
    if (this.previewType.dataFromAPI || this.previewType.adminPreview) {
      this.getCourseDetail()
    }
    else {
      // transferring and setting the local data
      this.sectionDataArr = this.dialogData;
      this.sectionId = 0;
      this.subSectionId = 0;
      this.sectionArr = this.transformArray(this.sectionDataArr);
      this.subSectionData = this.sectionDataArr[this.sectionId]["sub_s"][this.subSectionId];
      this.isBackAvailable = false
      if(this.previewType.themePreview){
        this.getTheme()
      }
      else{
        if(this.dialogData.tem_img){
          this.selectedTheme.tem_img=this.dialogData.tem_img
        }
        else{
          this.selectedTheme.tem_img=""
        }
      }
    }

    if(this.dialogData &&this.dialogData.hasOwnProperty('freePreview')){
    this.freePreviewTimOut= setTimeout(()=>{
      this.dialogRef.close()
      this.appService.showToastMessage('warning',"Time's up! To continue, unlock the full experience. Don't miss out - purchase now!")
     },10000)
    }
  }
  getTheme(){
    this.courseService.getTheme().subscribe({next: (success: any) => {
       if(success.status==200){
        this.themeArr=[]
        this.themeArr=success.msg
        if(this.dialogData.tem_img){
          this.selectedTheme = this.themeArr.find(item => item.tem_img === this.dialogData.tem_img)
        }
        else{
          this.selectedTheme.tem_img=""
          // this.selectedTheme=this.themeArr[0]
        }
       }
    },error:(error)=>{
     
    }})
  }
  transformArray(originalArray: any[]): TransformedObject[] {
    const transformedArray: TransformedObject[] = [];
    originalArray.forEach((item, i) => {
      const transformedObject: TransformedObject = {
        id: i,
        arr: [],
      };
      // transformedObject.arr.push(i);
      if (item.sub_s && Array.isArray(item.sub_s)) {
        item.sub_s.forEach((subItem, j) => {
          transformedObject.arr.push(j);
        });
      }
      transformedArray.push(transformedObject);
    });
    return transformedArray;
  }
  onBack() {
    let currentSectionIdIndex = this.sectionArr.findIndex(i => i.id == this.sectionId);
    let currentSubSectionIndex = this.sectionArr[currentSectionIdIndex]["arr"].findIndex(i => i == this.subSectionId)
    // current sub section is not first item of section id's arr then do -1 of current sub section index
    if (currentSubSectionIndex > 0) {
      this.subSectionId = this.sectionArr[currentSectionIdIndex]["arr"][currentSubSectionIndex - 1]
    }
    // if current sub section is first item of section array then -1 section and go one section up nad then view its last sub seciton as user is going back
    else {
      if (currentSectionIdIndex > 0) {
        this.sectionId = this.sectionArr[currentSectionIdIndex - 1]["id"]
        this.subSectionId = this.sectionArr[currentSectionIdIndex - 1]["arr"][this.sectionArr[currentSectionIdIndex - 1]["arr"].length - 1]
      }
    }
    if (this.dialogData && this.dialogData.parentMenu != 'preview_course') {
      this.subSectionData = this.sectionDataArr[this.sectionId]["sub_s"][this.subSectionId]
      this.getBackBtn()
    }
    else {
      this.getCourseSubSectionDetail()
    }
  }
  getBackBtn() {
    let currentSectionIdIndex = this.sectionArr.findIndex(i => i.id == this.sectionId);
    let currentSubSectionIndex = this.sectionArr[currentSectionIdIndex]["arr"].findIndex(i => i == this.subSectionId)
    if (currentSectionIdIndex == 0 && currentSubSectionIndex == 0) {
      this.isBackAvailable = false
    }
    else {
      this.isBackAvailable = true;
    }

  }
  onNext() {
    this.getNextId()
    if (this.dialogData && this.dialogData.parentMenu != 'preview_course') {
      // on init we are hiding the back button hence enabling it on first next button
      this.isBackAvailable = true;
      let obj = this.sectionDataArr[this.sectionId]["sub_s"][this.subSectionId]
      if (obj["type"] == "exam") {
        // alert("Exam")
        this.examData.e_i = obj["e_i"]
        this.subSectionData = obj
      }
      else {
        this.subSectionData = this.sectionDataArr[this.sectionId]["sub_s"][this.subSectionId]
      }

    }
    else {
      this.getCourseSubSectionDetail()
    }
  }
  getNextId() {
    // this.isCourseCompleted=false;
    let currentSectionIdIndex = this.sectionArr.findIndex(i => i.id == this.sectionId);
    if (currentSectionIdIndex + 1 <= this.sectionArr.length) {
      let currentSubSectionIndex = this.sectionArr[currentSectionIdIndex]["arr"].findIndex(i => i == this.subSectionId)
      //should not be last sub section
      //if last sub section then move to next section's first sub section
      if (this.sectionArr[currentSectionIdIndex]["arr"].length == currentSubSectionIndex + 1) {
        if (currentSectionIdIndex + 1 != this.sectionArr.length) {
          this.sectionId = this.sectionArr[currentSectionIdIndex + 1]["id"]
          this.subSectionId = this.sectionArr[currentSectionIdIndex + 1]["arr"][0]
        }
        else {
          this.completedAlert()
          // this.isCourseCompleted=true
        }
      }
      else {
        this.subSectionId = this.sectionArr[currentSectionIdIndex]["arr"][currentSubSectionIndex + 1];
      }
      return
    }
    else {
      this.completedAlert()
      // this.isCourseCompleted=true
    }
  }
  completedAlert() {
    const dialogRef = this.dialog.open(AlertComponent, Object.assign({
      data: { api_type: 'completed_view_course', }
    }));
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }
  onPlayPauseAudio() {
    // this.isPlayButton = !this.isPlayButton;
    const audioElement: HTMLAudioElement = this.audio.nativeElement;
    if (audioElement.paused) {
      audioElement.play();
      this.isPlayButton = false
    }
    else {
      this.isPlayButton = true
      audioElement.pause();
    }
  }
  onChangePreviewType(value: string) {
    this.coursePreviewType = value
    this.cd.detectChanges()
  }
  onSubSection(s_i: any, item: any) {
    if (!this.previewType.dataFromAPI) {
      this.subSectionData = item
    }
    else {
      this.sectionId = s_i;
      this.subSectionId = item["s_si"]
      this.getCourseSubSectionDetail()
    }
  }
  extractVideoId(url: string) {
    let videoId = '';
    if (url.includes("youtube.com/watch")) {
      const start = url.indexOf("v=") + 2;
      let end: any = url.indexOf("&", start);
      if (end === -1) {
        end = undefined;
      }
      videoId = url.substring(start, end);
      return this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/" + videoId)
    } else if (url.includes("youtube.com/shorts/")) {
      const urlParts = url.split("/");
      videoId = urlParts[urlParts.length - 1];
      return this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/" + videoId)
    } else {
      return ""
    }
  }
  onSelectTheme(item: any) {
   this.selectedTheme=item
  }
  getCourseDetail() {
    let data
    if (this.previewType.adminPreview) {
      data = {
        "c_i": this.cookieService.get('course_id'),
        "t": this.cookieService.get('c_t'),//course type from cookie
      }
    }
    else {
      data = {
        "c_i": this.dialogData.id,
        "t": this.dialogData.t,//course type from cookie
      }
    }
    this.courseService.getCourseDetail(data).subscribe({
      next: (success: any) => {
        this.sectionDataArr = []
        this.sectionArr = []
        this.sectionArr = [...success.data.section_arr]
        this.sectionDataArr = [...success.data.section]
        this.sectionId = this.sectionDataArr[0]["s_i"]
        this.subSectionId = this.sectionDataArr[0]["sub_s"][0]["s_si"]
        this.getCourseSubSectionDetail()
      },
      error: (error: any) => { }
    })
  }
  getCourseSubSectionDetail() {
    let data = {
      "c_i": this.courseId,
      "t": this.courseType,
      "s_i": this.sectionId,
      "s_si": this.subSectionId,
    }
    if (this.previewType.adminPreview) {
      data["c_i"] = this.cookieService.get('course_id'),
        data["t"] = this.cookieService.get('c_t')
    }
    else {
      data["c_i"] = this.dialogData.id,
        data["t"] = this.dialogData.t
    }
    this.spinner.show()
    this.courseService.getSubSectionDetail(data).subscribe({
      next: (success: any) => {
        this.spinner.hide()
        this.subSectionData = success.data["sub_s"][0]
        // this.themeUrl = success.data["tem_img"]
        this.selectedTheme.tem_img=success.data["tem_img"]
        if (this.subSectionData.type == "exam") {
          this.examData.e_i = this.subSectionData["e_i"]
        }
        this.getBackBtn()
      },
      error: (error: any) => {
        this.spinner.hide()
      }
    })
  }
  examComponentEvent(event) {
    this.onNext()
  }
  onCancel() {
    this.dialogRef.close()
  }
  onApply() {
    this.dialogRef.close({ data: this.selectedTheme })
  }
  onDownload() {
    this.appService.downloadFile(this.subSectionData.subs_cont, 'course_data')
  }
  ngOnDestroy(){
    clearTimeout(this.freePreviewTimOut);
  }
}
